import React from 'react'
import PropTypes from 'prop-types'
import { cn } from 'src/utils/cn'
import { StarSvg } from '../components/Svgs/StarSvg'

const ChatbotIconButton = ({ onClick, className }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label="Chat with us"
    className={cn(
      'flex items-center justify-center rounded-full p-3',
      'bg-white',
      'shadow-[1px_5px_9.9px_0px_rgba(20,46,87,0.05),0px_13px_32px_0px_rgba(29,37,47,0.0776)]',
      'border border-solid border-blue-390',
      className
    )}
  >
    <span
      className={cn(
        'flex items-center justify-center gap-1 rounded-full px-4 py-2 text-lg',
        'bg-blue-accent transition-all duration-300 hover:bg-[#082178]'
      )}
    >
      <StarSvg />
      <span className="font-bold text-white">Chat with us</span>
    </span>
  </button>
)

ChatbotIconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
}

export default ChatbotIconButton
